import { observable } from 'mobx';

class SnackBarStore {
  @observable message = '';
  @observable isOpen = false;
  setMessage = (message) => {
    this.isOpen = true;
    this.message = typeof message === 'string' ? message : message.message;
  };
  handleRequestClose = () => {
    this.isOpen = false;
  };
}

export default SnackBarStore;
